"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_UPSELLS_PREFIX = void 0;
exports.getFeatureUpsellUrl = getFeatureUpsellUrl;
exports.FEATURE_UPSELLS_PREFIX = "/embed/upsell";
function getFeatureUpsellUrl({ featureKey, isLimitHit = false, }) {
    const formattedKey = featureKey.toLowerCase();
    const suffix = isLimitHit ? "_limit" : "";
    return `${exports.FEATURE_UPSELLS_PREFIX}/${formattedKey}${suffix}`;
}
